function handleDarkMode() {
    // Helper function to calculate the theme setting as a string
    function calculateSettingAsThemeString(localStorageTheme, systemSettingDark) {
      if (localStorageTheme !== null) {
        return localStorageTheme;
      }
      return systemSettingDark.matches ? "dark" : "light";
    }
  
    // Helper function to update the theme on the HTML element
    function updateThemeOnHtmlEl(theme) {
      document.documentElement.setAttribute("data-theme", theme);
    }
  
    // Initial setup
    const button = document.querySelector("[data-theme-toggle]");
    if (!button) return; // Exit if button is not found
  
    const localStorageTheme = localStorage.getItem("theme");
    const systemSettingDark = window.matchMedia("(prefers-color-scheme: dark)");
  
    let currentThemeSetting = calculateSettingAsThemeString(localStorageTheme, systemSettingDark);
  
    updateThemeOnHtmlEl(currentThemeSetting);
  
    // Event listener for theme toggle button
    button.addEventListener("click", () => {
      const newTheme = currentThemeSetting === "dark" ? "light" : "dark";
  
      localStorage.setItem("theme", newTheme);
      updateThemeOnHtmlEl(newTheme);
  
      currentThemeSetting = newTheme;
    });
  
    // Listener for system theme changes
    systemSettingDark.addEventListener('change', (event) => {
      if (!localStorage.getItem("theme")) {
        const newSystemTheme = event.matches ? "dark" : "light";
        updateThemeOnHtmlEl(newSystemTheme);
        currentThemeSetting = newSystemTheme;
      }
    });
  }
  
  // Apply the theme as soon as the script loads
  handleDarkMode();
  
  export default {
    init: handleDarkMode // Ensure the function can be re-initialized if needed
  };
  